import { matchRoutes, getDvaApp, history } from "@umijs/max";
import { message } from "antd";
import "./app.less";
import "./style/main.less";
import { getLoginToken } from "@/models/userInfo";
import "./app-initialization/index";
import { dispatch } from "./app-initialization/tools";
import PubSub from "pubsub-js";
import { MOBILE_PREFIX, PubSubType } from "@/const";
import { userAgent } from "./utils/utils";
import { initChatAbnormalReporter } from "./utils/chatAbnormalReporter";
import { clearLoginReturnRoute, getLoginBackground, prepareLoginReturnRoute, readLoginReturnRoute, rememberLoginBackground, routeWithoutEmbedding } from './utils/login-route-background';
import { isWorkspaceEmbedded } from './utils/workspace-embedded';
import { isMaintenanceRoute } from './utils/maintenance-route';

initChatAbnormalReporter();

// message 数量限制 最多1条
message.config({
  maxCount: 1,
  top: 50,
});

// 路由变更之后
export function onRouteChange({ location, clientRoutes }: any) {
  const route = matchRoutes(clientRoutes, location.pathname)?.pop()
    ?.route as NRouter.IItem;

  const visitMustLogin = !!(route && route.meta?.visitMustLogin);

  document.body.classList.toggle("visit-must-login", visitMustLogin);

  if (isMaintenanceRoute(location.pathname)) return;

  if (!getLoginToken()) {
    const fallback = getLoginBackground(location.pathname, location.search, visitMustLogin);
    const current = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    if (fallback) {
      const target = routeWithoutEmbedding(location.pathname, location.search, location.hash);
      const background = prepareLoginReturnRoute(target, fallback);
      if (isWorkspaceEmbedded()) window.parent.location.replace(background);
      else history.replace(background);
      return;
    }
    const pending = isWorkspaceEmbedded() ? null : readLoginReturnRoute();
    if (pending && pending.background !== current) clearLoginReturnRoute();
    if (visitMustLogin || pending?.background === current) {
      dispatch({ type: 'userParameter/setHasLoginPop', payload: true });
    }
    // iframe 自己的会员地址不可作为外层工作区的背景。
    if (!isWorkspaceEmbedded() && !visitMustLogin && !route?.meta?.noCommonPops && !new URLSearchParams(location.search).has('legacyview')) rememberLoginBackground(current);
  }

  // @ts-ignore
  const activePath = route?.originPath;

  if (activePath === "/") {
    PubSub.publish(PubSubType.CLOSE_SIDEBAR_HISTORY_LIST);
  }
}
